__turbopack_context__.v({
  "answer": "FAQItem-module-scss-module__pfPR4G__answer",
  "faqItem": "FAQItem-module-scss-module__pfPR4G__faqItem",
  "question": "FAQItem-module-scss-module__pfPR4G__question",
});
